<template>
    <div v-if="showDialog" class="custom-dialog" @mouseup.stop>
        <ElDialog
            :title="$t('snapBusiness.comment.DeleteCommentConfirm.title')"
            :width="`${width}px`"
            :customClass="[className, 'center', 'custom-dialog_el-dialog', 'el-namescape-wxl__override', title ? '' : 'no-title'].join(' ')"
            :closeOnClickModal="false"
            :closeOnPressEscape="false"
            :visible="true"
            :appendToBody="true"
            @close="onClose"
        >
            <div slot="title" @mouseup.stop>
                {{ $t('snapBusiness.comment.DeleteCommentConfirm.title') }}
            </div>
            <div @mouseup.stop>
                <div>{{ content }}</div>
            </div>
            <div slot="footer" @mouseup.stop>
                <div>
                    <button
                        class="pt-ui-btn"
                        data-type="default"
                        data-size="medium"
                        @mouseup.stop
                        @click="onCancel"
                    >
                        {{ cancelText ? cancelText : $t('snapBusiness.comment.DeleteCommentConfirm.cancel') }}
                    </button>
                    <button
                        class="pt-ui-btn"
                        data-type="danger"
                        data-size="medium"
                        @mouseup.stop
                        @click="onConfirm"
                    >
                        {{ confirmText ? confirmText : $t('global.btn.confirm') }}
                    </button>
                </div>
            </div>
        </ElDialog>
    </div>
</template>

<script>
import { dialog } from 'element-ui';

export default {
    name: 'CustomDialog',
    components: {
        ElDialog: dialog,
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String,
            default: 'confirm',
        },
        content: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        confirmText: {
            type: String,
            default: '',
        },
        cancelText: {
            type: String,
            default: '',
        },
        width: {
            type: Number,
            default: 360,
        },
    },
    computed: {
        className() {
            return `custom-dialog__${this.type}-type`;
        },
    },
    methods: {
        onClose() {
            this.$emit('update:showDialog', false);
        },
        onCancel() {
            this.$emit('cancel', false);
            this.onClose();
        },
        onConfirm() {
            this.$emit('confirm', false);
            this.onClose();
        },
    },
};
</script>

<style lang="scss">
    .custom-dialog {
        .modal-container {
            padding: 16px;
            background-image: none;
        }
        .modal-header {
            font-size: 16px;
            line-height: 24px;
            font-weight: 700;
            color: #061632;
        }
        .modal-body {
            margin-top: 16px;
        }
        .modal-footer {
            padding: 0;
            padding-top: 24px;
            text-align: right;
            button + button {
              margin-left: 8px;
            }
        }
        .modal-close-btn {
            display: none;
        }
        &_el-dialog.el-dialog[role=dialog] {
            .el-dialog__header {
                font-size: 18px;
            }
        }
    }
</style>
